import { render, staticRenderFns } from "./wf-overridable-optional-duration-edit.vue?vue&type=template&id=542a1191&scoped=true&"
import script from "./wf-overridable-optional-duration-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-overridable-optional-duration-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-overridable-optional-duration-edit.vue?vue&type=style&index=0&id=542a1191&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542a1191",
  null
  
)

export default component.exports